import Component from "./Media";
import BottomLeftAddon from "./components/Addons/BottomLeftAddon/MediaBottomLeftAddon";
import BottomRightAddon from "./components/Addons/BottomRightAddon/MediaBottomRightAddon";
import CenterAddon from "./components/Addons/CenterAddon/MediaCenterAddon";
import TopLeftAddon from "./components/Addons/TopLeftAddon/MediaTopLeftAddon";
import TopRightAddon from "./components/Addons/TopRightAddon/MediaTopRightAddon";
import Content from "./components/Content/MediaContent";

export interface IMediaExtentions {
    Content: typeof Content;
    TopRightAddon: typeof TopRightAddon;
    TopLeftAddon: typeof TopLeftAddon;
    BottomLeftAddon: typeof BottomLeftAddon;
    BottomRightAddon: typeof BottomRightAddon;
    CenterAddon: typeof CenterAddon;
}

export const Media: typeof Component & IMediaExtentions = Object.assign(
    Component,
    {
        Content,
        TopRightAddon,
        TopLeftAddon,
        BottomLeftAddon,
        BottomRightAddon,
        CenterAddon,
    },
);

export type { MediaProps, IAspectRatioValues, AspectRatioType } from "./types";
